module.exports = __webpack_public_path__ + "static/media/dashborad_selected.61998568.svg";